import React from "react";
import { CARD_CLASS } from "../uiConstants";
import { type Scores } from "../../vowGameLogic";
import { SCORE_LIST } from "../scoreMetadata";

type ScoreSummaryGridProps = {
  scores: Scores;
};

const ScoreSummaryGrid: React.FC<ScoreSummaryGridProps> = ({ scores }) => (
  <section className={`${CARD_CLASS} rounded-lg px-3 py-3`} id="scores">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h3 className="text-base font-semibold text-slate-900">Ecosystem Statistics</h3>
      <span className="text-[10px] font-medium uppercase tracking-[0.14em] text-slate-600">
        Current Year
      </span>
    </div>

    <dl className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
      {SCORE_LIST.map(({ key, label, description }) => (
        <div
          key={key}
          className="flex flex-col gap-[2px] rounded border border-black/30 bg-black/5 px-2 py-2"
        >
          <dt className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-700">
            {label}
          </dt>
          <dd className="text-xl font-bold leading-tight text-slate-900">
            {Math.round(scores[key])}
          </dd>
          <span className="text-[10px] leading-tight text-slate-700">
            {description}
          </span>
        </div>
      ))}
    </dl>
  </section>
);

export default ScoreSummaryGrid;
